import { gql } from '@apollo/client';

export const GET_VOLUNTEER_DATABASE_RECOGNITION_OPTIONS = gql`
  query GetVolunteerDatabaseRecognitionOptions {
    vm {
      achievements {
        achievementId
        name
        isEnabled
        levels {
          achievementLevelId
          name
          position
        }
      }
      certificateTemplates {
        certificateTemplateId
        name
      }
    }
  }
`;
